/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetGipAltReportExportStatusQueryResponse, GetGipAltReportExportStatusPathParams, GetGipAltReportExportStatus404 } from "../models/GetGipAltReportExportStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getGipAltReportExportStatus } from "../axios/getGipAltReportExportStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getGipAltReportExportStatusQueryKey = (id: GetGipAltReportExportStatusPathParams["id"]) => ["audit-reports-api", { url: '/reports/gip-alt/report/:id/export-status', params: {id:id} }] as const

export type GetGipAltReportExportStatusQueryKey = ReturnType<typeof getGipAltReportExportStatusQueryKey>

export function getGipAltReportExportStatusQueryOptions(id: GetGipAltReportExportStatusPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getGipAltReportExportStatusQueryKey(id)
        return queryOptions<GetGipAltReportExportStatusQueryResponse, ResponseErrorConfig<GetGipAltReportExportStatus404>, GetGipAltReportExportStatusQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getGipAltReportExportStatus(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get export job status for report
 * {@link /reports/gip-alt/report/:id/export-status}
 */
export function useGetGipAltReportExportStatus<TData = GetGipAltReportExportStatusQueryResponse, TQueryData = GetGipAltReportExportStatusQueryResponse, TQueryKey extends QueryKey = GetGipAltReportExportStatusQueryKey>(id: GetGipAltReportExportStatusPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetGipAltReportExportStatusQueryResponse, ResponseErrorConfig<GetGipAltReportExportStatus404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getGipAltReportExportStatusQueryKey(id)
         

         const query = useQuery({
          ...getGipAltReportExportStatusQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetGipAltReportExportStatus404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}